import { MapPin, Car } from "lucide-react";
import { FadeIn } from "./Reveal";

const TOWNS = ["Wieliczka", "Skawina", "Zabierzów", "Mogilany", "Liszki", "Czernichów", "Zielonki", "Świątniki Górne"];

export default function ServiceMap() {
    return (
        <section id="zasięg" className="bg-white py-24 md:py-32">
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 md:px-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <FadeIn>
                        <div className="mb-6 flex items-center gap-3">
                            <span className="font-mono text-xs font-semibold tracking-[0.3em] text-gold">ZASIĘG</span>
                            <span className="h-px w-10 bg-ink/20" />
                            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-ink/50">Obszar działania</span>
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.08}>
                        <h2 className="font-display text-4xl font-bold tracking-tighter text-ink sm:text-5xl">
                            Kraków i okolice<span className="text-gold">.</span>
                        </h2>
                    </FadeIn>
                    <FadeIn delay={0.15}>
                        <p className="mt-7 max-w-md text-base leading-relaxed text-ink/60">
                            Działamy w Krakowie oraz w promieniu około 30–40 km. Dojazd na darmową
                            wycenę jest zawsze gratis — niezależnie od wielkości zlecenia.
                        </p>
                    </FadeIn>
                    <FadeIn delay={0.22}>
                        <div className="mt-8 flex items-center gap-3 rounded-2xl border border-gold/40 bg-gold/10 p-5">
                            <span className="rounded-xl bg-gold p-2.5 text-ink">
                                <Car className="h-5 w-5" />
                            </span>
                            <p className="text-sm font-medium text-ink">
                                Dojazd i wycena <span className="font-bold">0 zł</span> na całym obszarze działania
                            </p>
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.3}>
                        <p className="mt-8 text-xs font-semibold uppercase tracking-[0.25em] text-ink/40">Przykładowe miejscowości</p>
                        <ul className="mt-4 flex flex-wrap gap-2">
                            {TOWNS.map((t) => (
                                <li key={t} className="flex items-center gap-1.5 rounded-full bg-mist px-3.5 py-1.5 text-xs font-medium text-ink/60">
                                    <MapPin className="h-3 w-3 text-gold" />
                                    {t}
                                </li>
                            ))}
                        </ul>
                    </FadeIn>
                </div>
                <FadeIn delay={0.15} y={40} className="lg:col-span-7">
                    <div className="relative">
                        <div className="absolute -inset-3 -rotate-1 rounded-[2rem] border-2 border-gold/60" aria-hidden />
                        <div
                            data-testid="service-map"
                            className="relative z-10 h-[380px] overflow-hidden rounded-[2rem] border border-ink/8 shadow-xl md:h-[460px]"
                            aria-label="Mapa obszaru działania — Kraków i okolice"
                        >
                            <img
                                src="/mapa-krakow.png"
                                alt="Mapa — Kraków i okolice, obszar działania Handy's"
                                className="h-full w-full object-cover"
                                loading="lazy"
                            />
                            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                                <span className="block h-4 w-4 rounded-full border-[3px] border-ink bg-gold shadow-[0_0_0_6px_rgba(255,179,0,0.35)]" />
                                <span className="absolute left-1/2 top-full mt-2.5 -translate-x-1/2 whitespace-nowrap rounded-full bg-ink px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-wider text-white shadow-lg">
                                    Handy&rsquo;s — Kraków i okolice
                                </span>
                            </div>
                        </div>
                        <p className="mt-3 text-right text-[10px] text-ink/30">© OpenStreetMap contributors</p>
                    </div>
                </FadeIn>
            </div>
        </section>
    );
}
